@use "@fukuri-admins/ui/layout" as *;

.formTitle {
  @include typography('Jp/20_W6');
  margin: 0;
  color: text('High');
}

.form {
  width: 100%;
}

.formContainer {
  max-width: 480px;
}
